export const SEARCH_VIEW_PDF_NO = 3;
export const PREVIEW_EXTENSIONS = ['pdf'];
